import { type EventParticipant, isRegisteredEventParticipant } from 'models';
import { useCallback } from 'react';
import { useUser } from 'features/auth';

export const useIsViewerEventInvitee = () => {
  const {
    nodeUserData: { _id },
  } = useUser();

  return useCallback(
    (invitee: EventParticipant) => isRegisteredEventParticipant(invitee) && _id === invitee.ref,
    [_id],
  );
};
